import React from "react";

export function PageHeader({ eyebrow, title, description, actions, testid }) {
  return (
    <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-8 pb-6 border-b border-zinc-800" data-testid={testid}>
      <div>
        {eyebrow && <div className="label-caps mb-3">{eyebrow}</div>}
        <h1 className="font-display font-black text-3xl md:text-4xl tracking-tighter">{title}</h1>
        {description && (
          <p className="text-sm text-zinc-400 mt-2 max-w-2xl">{description}</p>
        )}
      </div>
      {actions && <div className="flex gap-2">{actions}</div>}
    </div>
  );
}

export function KpiCard({ label, value, sub, tone = "default", testid }) {
  const toneMap = {
    default: "text-zinc-100",
    amber: "text-amber-400",
    success: "text-emerald-400",
    danger: "text-red-400",
  };
  return (
    <div className="p-5 bg-[#0e0e11] border border-zinc-800 flex flex-col justify-between min-h-[128px]" data-testid={testid}>
      <div className="label-caps">{label}</div>
      <div className={`font-display font-black text-4xl tracking-tighter tabular-nums ${toneMap[tone]}`}>
        {value}
      </div>
      {sub && <div className="text-[11px] font-mono text-zinc-500">{sub}</div>}
    </div>
  );
}

export function Panel({ title, children, actions, className = "" }) {
  return (
    <div className={`bg-[#0e0e11] border border-zinc-800 ${className}`}>
      {(title || actions) && (
        <div className="flex items-center justify-between px-5 h-11 border-b border-zinc-800">
          <div className="label-caps">{title}</div>
          {actions}
        </div>
      )}
      <div>{children}</div>
    </div>
  );
}

export function EmptyState({ message = "No data yet." }) {
  return (
    <div className="p-12 text-center text-xs uppercase tracking-[0.3em] text-zinc-600">
      {message}
    </div>
  );
}
